import React from "react";

import ReducerContextProvider from "../../shared/ReducerContext/ReducerContextProvider";

const wrapWithReducerContext = ({ Component, reducer }) => props => (
  <ReducerContextProvider initialData={props?.state} reducer={reducer}>
    <Component {...props} />
  </ReducerContextProvider>
);

export default wrapWithReducerContext;
